import { Box, styled } from "@mui/material";

const StyledTabFilters = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'space-around',
    backgroundColor: (theme as any).palette.neutral.darker,
    borderRadius: (theme as any).shape.border.general.radius[8],
    padding: theme.spacing(0.2),
    
}))

export { StyledTabFilters };